var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn",attrs:{"to":_vm.href}},[_c('hr'),_c('span',{staticClass:"btn--content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }